/**
 * storeFavicon.ts — the square icon shown in the browser tab.
 *
 * Why this exists: without an entry here the tab icon falls back to
 * `store.logoUrl`, which is the wide horizontal logo — squeezed into 16×16 it
 * turns into an unreadable smear. A store with a square brand icon registers
 * it here (same per-store keying pattern as `storeDisplayName.ts`), so no
 * Firestore change is needed.
 */
import balasiFavicon from "../websites/balasistore/brand/favicon-192.png";

const STORE_FAVICONS: Partial<Record<string, string>> = {
	balasistore_store: balasiFavicon,
};

export function getStoreFavicon(storeId?: string): string | undefined {
	return storeId ? STORE_FAVICONS[storeId] : undefined;
}
